export default {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  center: { lat: 9.911, lng: -84.52 },
  zoom: 12
}
